import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 5rem 0;

  h1 {
    margin-bottom: 4rem;
  }
`;
